import {createReducer, on} from '@ngrx/store';

import {PaymentType} from '../../requests/constants/request-details.constants';
import {PopItemTypeModel} from '../../requests/models/pop-design-request.model';
import {Warehouse} from '../../requests/models/warehouse.model';
import {CodeNameModel} from '../../shared/models/code-name.model';
import {
  clearIhHealthPrograms,
  loadArtLocationsTypes,
  loadArtLocationsTypesFailure,
  loadArtLocationsTypesSuccess,
  loadBifComponentTypes,
  loadBifComponentTypesFailure,
  loadBifComponentTypesSuccess,
  loadBifFulfillmentTypes,
  loadBifFulfillmentTypesFailure,
  loadBifFulfillmentTypesSuccess,
  loadChannelTypes,
  loadChannelTypesFailure,
  loadChannelTypesSuccess,
  loadColorTypes,
  loadColorTypesFailure,
  loadColorTypesSuccess,
  loadCompanies,
  loadCompaniesFailure,
  loadCompaniesSuccess,
  loadComponentTypes,
  loadComponentTypesFailure,
  loadComponentTypesSuccess,
  loadDataPinFileTypes,
  loadDataPinFileTypesFailure,
  loadDataPinFileTypesSuccess,
  loadDesignLineOfBusiness,
  loadDesignLineOfBusinessFailure,
  loadDesignLineOfBusinessSuccess,
  loadDesignSourceTypes,
  loadDesignSourceTypesFailure,
  loadDesignSourceTypesSuccess,
  loadDielines,
  loadDielinesFailure,
  loadDielinesSuccess,
  loadDimensionTypes,
  loadDimensionTypesFailure,
  loadDimensionTypesSuccess,
  loadFinancialTypes,
  loadFinancialTypesFailure,
  loadFinancialTypesSuccess,
  loadFSPaymentTypes,
  loadFSPaymentTypesFailure,
  loadFSPaymentTypesSuccess,
  loadIhComponents,
  loadIhComponentsFailure,
  loadIhComponentsSuccess,
  loadIhHealthPlans,
  loadIhHealthPlansFailure,
  loadIhHealthPlansSuccess,
  loadIhHealthPrograms,
  loadIhHealthProgramsFailure,
  loadIhHealthProgramsSuccess,
  loadIhPriorities,
  loadIhPrioritiesFailure,
  loadIhPrioritiesSuccess,
  loadImageFormatTypes,
  loadImageFormatTypesFailure,
  loadImageFormatTypesSuccess,
  loadInventoryTypes,
  loadInventoryTypesFailure,
  loadInventoryTypesSuccess,
  loadRequestTypeInventoryTypes,
  loadRequestTypeInventoryTypesFailure,
  loadRequestTypeInventoryTypesSuccess,
  loadPartnerGroups,
  loadPartnerGroupsFailure,
  loadPartnerGroupsSuccess,
  loadPaymentTypes,
  loadPaymentTypesFailure,
  loadPaymentTypesSuccess,
  loadPopChannelTypes,
  loadPopChannelTypesFailure,
  loadPopChannelTypesSuccess,
  loadPopItemTypes,
  loadPopItemTypesFailure,
  loadPopItemTypesSuccess,
  loadPopProdCuttingTypes,
  loadPopProdCuttingTypesFailure,
  loadPopProdCuttingTypesSuccess,
  loadPopProdEventTypes,
  loadPopProdEventTypesFailure,
  loadPopProdEventTypesSuccess,
  loadPopProdFundingTypes,
  loadPopProdFundingTypesFailure,
  loadPopProdFundingTypesSuccess,
  loadPopProdInventoryTypes,
  loadPopProdInventoryTypesFailure,
  loadPopProdInventoryTypesSuccess,
  loadPopProdItemTypes,
  loadPopProdItemTypesFailure,
  loadPopProdItemTypesSuccess,
  loadPopProdMaterialTypes,
  loadPopProdMaterialTypesFailure,
  loadPopProdMaterialTypesSuccess,
  loadPopProdTapeTypes,
  loadPopProdTapeTypesFailure,
  loadPopProdTapeTypesSuccess,
  loadPopProdUsageDurationTypes,
  loadPopProdUsageDurationTypesFailure,
  loadPopProdUsageDurationTypesSuccess,
  loadPrinters,
  loadPrintersFailure,
  loadPrintersSuccess,
  loadRedemptionTypes,
  loadRedemptionTypesFailure,
  loadRedemptionTypesSuccess,
  loadRegions,
  loadRegionsFailure,
  loadRegionsSuccess,
  loadRequestItemTypes,
  loadRequestItemTypesFailure,
  loadRequestItemTypesSuccess,
  loadReturnFileTypes,
  loadReturnFileTypesFailure,
  loadReturnFileTypesSuccess,
  loadSubstrates,
  loadSubstratesFailure,
  loadSubstratesSuccess,
  loadThirdPartyDataPinFileTypes,
  loadThirdPartyDataPinFileTypesFailure,
  loadThirdPartyDataPinFileTypesSuccess,
  loadThirdPartyOrderTypes,
  loadThirdPartyOrderTypesFailure,
  loadThirdPartyOrderTypesSuccess,
  loadThirdPartyPrintOwnerTypes,
  loadThirdPartyPrintOwnerTypesFailure,
  loadThirdPartyPrintOwnerTypesSuccess,
  loadThirdPartyCompanies,
  loadThirdPartyCompaniesFailure,
  loadThirdPartyCompaniesSuccess,
  loadWarehouses,
  loadWarehousesFailure,
  loadWarehousesSuccess
} from './refdata.actions';

export const requestRefDataFeatureKey = 'refData';

export interface RequestRefDataState {
  paymentTypes: PaymentType[];
  fsPaymentTypes: PaymentType[];
  dielines: CodeNameModel[];
  dataPinFileTypes: CodeNameModel[];
  substrates: CodeNameModel[];
  redemptionTypes: CodeNameModel[];
  requestItemTypes: CodeNameModel[];
  regions: CodeNameModel[];
  warehouses: Warehouse[];
  companies: CodeNameModel[];
  partnerGroups: CodeNameModel[];
  designLineOfBusiness: CodeNameModel[];
  artLocationTypes: CodeNameModel[];
  designSourceTypes: CodeNameModel[];
  channelTypes: CodeNameModel[];
  popChannelTypes: CodeNameModel[];
  inventoryTypes: CodeNameModel[];
  requestTypeInventoryTypes: CodeNameModel[];
  componentTypes: CodeNameModel[];
  popItemTypes: PopItemTypeModel[];
  colorTypes: CodeNameModel[];
  dimensionTypes: CodeNameModel[];
  financialTypes: CodeNameModel[];
  popProdEventTypes: CodeNameModel[];
  popProdFundingTypes: Array<
    CodeNameModel & {
      mask?: string;
      tooltip?: string;
    }
  >;
  popUsageDurationTypes: CodeNameModel[];
  popProdItemTypes: PopItemTypeModel[];
  popProdCuttingTypes: CodeNameModel[];
  popProdMaterialTypes: CodeNameModel[];
  popProdTapeTypes: CodeNameModel[];
  popProdInventoryTypes: CodeNameModel[];
  printers: any[];
  bifComponentTypes: CodeNameModel[];
  bifFulfillmentTypes: CodeNameModel[];
  thirdPartyDataPinFileTypes: CodeNameModel[];
  thirdPartyOrderTypes: CodeNameModel[];
  thirdPartyPrintOwnerTypes: Array<CodeNameModel & {internal: boolean}>;
  thirdPartyCompanies: CodeNameModel[];
  ihComponents: CodeNameModel[];
  ihHealthPlans: CodeNameModel[];
  ihHealthPrograms: CodeNameModel[];
  ihPriorities: Array<CodeNameModel & {value: number}>;
  returnFileTypes: CodeNameModel[];
  imageFormatTypes: CodeNameModel[];
}

export const refDataInitialState: RequestRefDataState = {
  paymentTypes: [],
  fsPaymentTypes: [],
  dielines: [],
  dataPinFileTypes: [],
  substrates: [],
  redemptionTypes: [],
  requestItemTypes: [],
  regions: [],
  warehouses: [],
  companies: [],
  partnerGroups: [],
  designLineOfBusiness: [],
  artLocationTypes: [],
  designSourceTypes: [],
  channelTypes: [],
  popChannelTypes: [],
  inventoryTypes: [],
  requestTypeInventoryTypes: [],
  componentTypes: [],
  popItemTypes: [],
  colorTypes: [],
  dimensionTypes: [],
  financialTypes: [],
  popProdEventTypes: [],
  popProdFundingTypes: [],
  popUsageDurationTypes: [],
  popProdItemTypes: [],
  popProdCuttingTypes: [],
  popProdMaterialTypes: [],
  popProdTapeTypes: [],
  popProdInventoryTypes: [],
  printers: [],
  bifComponentTypes: [],
  bifFulfillmentTypes: [],
  thirdPartyDataPinFileTypes: [],
  thirdPartyOrderTypes: [],
  thirdPartyPrintOwnerTypes: [],
  thirdPartyCompanies: [],
  ihComponents: [],
  ihHealthPlans: [],
  ihHealthPrograms: [],
  ihPriorities: [],
  returnFileTypes: [],
  imageFormatTypes: []
};

export const refDataReducer = createReducer(
  refDataInitialState,

  on(loadPaymentTypes, state => ({...state, paymentTypes: []})),
  on(loadPaymentTypesSuccess, (state, action) => ({...state, paymentTypes: action.paymentTypes})),
  on(loadPaymentTypesFailure, state => ({...state, paymentTypes: []})),

  on(loadFSPaymentTypes, state => ({...state, fsPaymentTypes: []})),
  on(loadFSPaymentTypesSuccess, (state, action) => ({...state, fsPaymentTypes: action.fsPaymentTypes})),
  on(loadFSPaymentTypesFailure, state => ({...state, fsPaymentTypes: []})),

  on(loadDielines, state => ({...state, dielines: []})),
  on(loadDielinesSuccess, (state, action) => ({...state, dielines: action.dielines})),
  on(loadDielinesFailure, state => ({...state, dielines: []})),

  on(loadDataPinFileTypes, state => ({...state, dataPinFileTypes: []})),
  on(loadDataPinFileTypesSuccess, (state, action) => ({...state, dataPinFileTypes: action.dataPinFileTypes})),
  on(loadDataPinFileTypesFailure, state => ({...state, dataPinFileTypes: []})),

  on(loadSubstrates, state => ({...state, substrates: []})),
  on(loadSubstratesSuccess, (state, action) => ({...state, substrates: action.substrates})),
  on(loadSubstratesFailure, state => ({...state, substrates: []})),

  on(loadRedemptionTypes, state => ({...state, redemptionTypes: []})),
  on(loadRedemptionTypesSuccess, (state, action) => ({...state, redemptionTypes: action.redemptionTypes})),
  on(loadRedemptionTypesFailure, state => ({...state, redemptionTypes: []})),

  on(loadRequestItemTypes, state => ({...state, requestItemTypes: []})),
  on(loadRequestItemTypesSuccess, (state, action) => ({...state, requestItemTypes: action.requestItemTypes})),
  on(loadRequestItemTypesFailure, state => ({...state, requestItemTypes: []})),

  on(loadRegions, state => ({...state, regions: []})),
  on(loadRegionsSuccess, (state, action) => ({...state, regions: action.regions})),
  on(loadRegionsFailure, state => ({...state, regions: []})),

  on(loadWarehouses, state => ({...state, warehouses: []})),
  on(loadWarehousesSuccess, (state, action) => ({...state, warehouses: action.warehouses})),
  on(loadWarehousesFailure, state => ({...state, warehouses: []})),

  on(loadCompanies, state => ({...state, companies: []})),
  on(loadCompaniesSuccess, (state, action) => ({...state, companies: action.companies})),
  on(loadCompaniesFailure, state => ({...state, companies: []})),

  on(loadPopProdInventoryTypes, state => ({...state, popProdInventoryTypes: []})),
  on(loadPopProdInventoryTypesSuccess, (state, action) => ({...state, popProdInventoryTypes: action.popProdInventoryTypes})),
  on(loadPopProdInventoryTypesFailure, state => ({...state, popProdInventoryTypes: []})),

  on(loadPrinters, state => ({...state, printers: []})),
  on(loadPrintersSuccess, (state, action) => ({...state, printers: action.printers})),
  on(loadPrintersFailure, state => ({...state, popProdInvenprinterstoryTypes: []})),

  on(loadPartnerGroups, state => ({...state, partnerGroups: []})),
  on(loadPartnerGroupsSuccess, (state, action) => ({...state, partnerGroups: action.partnerGroups})),
  on(loadPartnerGroupsFailure, state => ({...state, partnerGroups: []})),

  on(loadDesignLineOfBusiness, state => ({...state, designLineOfBusiness: []})),
  on(loadDesignLineOfBusinessSuccess, (state, action) => ({...state, designLineOfBusiness: action.designLineOfBusiness})),
  on(loadDesignLineOfBusinessFailure, state => ({...state, designLineOfBusiness: []})),

  on(loadArtLocationsTypes, state => ({...state, artLocationTypes: []})),
  on(loadArtLocationsTypesSuccess, (state, action) => ({...state, artLocationTypes: action.artLocationTypes})),
  on(loadArtLocationsTypesFailure, state => ({...state, artLocationTypes: []})),

  on(loadDesignSourceTypes, state => ({...state, designSourceTypes: []})),
  on(loadDesignSourceTypesSuccess, (state, action) => ({...state, designSourceTypes: action.designSourceTypes})),
  on(loadDesignSourceTypesFailure, state => ({...state, designSourceTypes: []})),

  on(loadChannelTypes, state => ({...state, channelTypes: []})),
  on(loadChannelTypesSuccess, (state, action) => ({...state, channelTypes: action.channelTypes})),
  on(loadChannelTypesFailure, state => ({...state, channelTypes: []})),

  on(loadPopChannelTypes, state => ({...state, popChannelTypes: []})),
  on(loadPopChannelTypesSuccess, (state, action) => ({...state, popChannelTypes: action.popChannelTypes})),
  on(loadPopChannelTypesFailure, state => ({...state, popChannelTypes: []})),

  on(loadInventoryTypes, state => ({...state, inventoryTypes: []})),
  on(loadInventoryTypesSuccess, (state, action) => ({...state, inventoryTypes: action.inventoryTypes})),
  on(loadInventoryTypesFailure, state => ({...state, inventoryTypes: []})),

  on(loadRequestTypeInventoryTypes, state => ({...state, requestTypeInventoryTypes: []})),
  on(loadRequestTypeInventoryTypesSuccess, (state, action) => ({...state, requestTypeInventoryTypes: action.requestTypeInventoryTypes})),
  on(loadRequestTypeInventoryTypesFailure, state => ({...state, requestTypeInventoryTypes: []})),

  on(loadComponentTypes, state => ({...state, componentTypes: []})),
  on(loadComponentTypesSuccess, (state, action) => ({...state, componentTypes: action.componentTypes})),
  on(loadComponentTypesFailure, state => ({...state, componentTypes: []})),

  on(loadPopItemTypes, state => ({...state, popItemTypes: []})),
  on(loadPopItemTypesSuccess, (state, action) => ({...state, popItemTypes: action.popItemTypes})),
  on(loadPopItemTypesFailure, state => ({...state, popItemTypes: []})),

  on(loadColorTypes, state => ({...state, colorTypes: []})),
  on(loadColorTypesSuccess, (state, action) => ({...state, colorTypes: action.colorTypes})),
  on(loadColorTypesFailure, state => ({...state, colorTypes: []})),

  on(loadDimensionTypes, state => ({...state, dimensionTypes: []})),
  on(loadDimensionTypesSuccess, (state, action) => ({...state, dimensionTypes: action.dimensionTypes})),
  on(loadDimensionTypesFailure, state => ({...state, dimensionTypes: []})),

  on(loadFinancialTypes, state => ({...state, financialTypes: []})),
  on(loadFinancialTypesSuccess, (state, action) => ({...state, financialTypes: action.financialTypes})),
  on(loadFinancialTypesFailure, state => ({...state, financialTypes: []})),

  on(loadPopProdEventTypes, state => ({...state, popProdEventTypes: []})),
  on(loadPopProdEventTypesSuccess, (state, action) => ({...state, popProdEventTypes: action.popProdEventTypes})),
  on(loadPopProdEventTypesFailure, state => ({...state, popProdEventTypes: []})),

  on(loadPopProdFundingTypes, state => ({...state, popProdFundingTypes: []})),
  on(loadPopProdFundingTypesSuccess, (state, action) => ({...state, popProdFundingTypes: action.popProdFundingTypes})),
  on(loadPopProdFundingTypesFailure, state => ({...state, popProdFundingTypes: []})),

  on(loadPopProdUsageDurationTypes, state => ({...state, popUsageDurationTypes: []})),
  on(loadPopProdUsageDurationTypesSuccess, (state, action) => ({
    ...state,
    popUsageDurationTypes: action.popUsageDurationTypes
  })),
  on(loadPopProdUsageDurationTypesFailure, state => ({...state, popUsageDurationTypes: []})),

  on(loadPopProdItemTypes, state => ({...state, popProdItemTypes: []})),
  on(loadPopProdItemTypesSuccess, (state, action) => ({...state, popProdItemTypes: action.popProdItemTypes})),
  on(loadPopProdItemTypesFailure, state => ({...state, popProdItemTypes: []})),

  on(loadPopProdCuttingTypes, loadPopProdCuttingTypesFailure, state => ({...state, popProdItemTypes: []})),
  on(loadPopProdCuttingTypesSuccess, (state, {popProdCuttingTypes}) => ({
    ...state,
    popProdCuttingTypes
  })),

  on(loadPopProdMaterialTypes, loadPopProdMaterialTypesFailure, state => ({
    ...state,
    popProdMaterialTypes: []
  })),
  on(loadPopProdMaterialTypesSuccess, (state, {popProdMaterialTypes}) => ({
    ...state,
    popProdMaterialTypes
  })),

  on(loadPopProdTapeTypes, loadPopProdTapeTypesFailure, state => ({...state, popProdTapeTypes: []})),
  on(loadPopProdTapeTypesSuccess, (state, {popProdTapeTypes}) => ({
    ...state,
    popProdTapeTypes
  })),

  on(loadBifComponentTypes, state => ({...state, bifComponentTypes: []})),
  on(loadBifComponentTypesSuccess, (state, action) => ({...state, bifComponentTypes: action.bifComponentTypes})),
  on(loadBifComponentTypesFailure, state => ({...state, bifComponentTypes: []})),

  on(loadBifFulfillmentTypes, state => ({...state, bifFulfillmentTypes: []})),
  on(loadBifFulfillmentTypesSuccess, (state, action) => ({...state, bifFulfillmentTypes: action.bifFulfillmentTypes})),
  on(loadBifFulfillmentTypesFailure, state => ({...state, bifFulfillmentTypes: []})),
  /**
   * ThirdPartyDataPinFileTypes
   */
  on(loadThirdPartyDataPinFileTypes, state => ({...state, thirdPartyDataPinFileTypes: []})),
  on(loadThirdPartyDataPinFileTypesSuccess, (state, action) => ({
    ...state,
    thirdPartyDataPinFileTypes: action.thirdPartyDataPinFileTypes
  })),
  on(loadThirdPartyDataPinFileTypesFailure, state => ({...state, thirdPartyDataPinFileTypes: []})),
  /**
   * ThirdPartyOrderTypes
   */
  on(loadThirdPartyOrderTypes, state => ({...state, thirdPartyOrderTypes: []})),
  on(loadThirdPartyOrderTypesSuccess, (state, action) => ({...state, thirdPartyOrderTypes: action.thirdPartyOrderTypes})),
  on(loadThirdPartyOrderTypesFailure, state => ({...state, thirdPartyOrderTypes: []})),
  /**
   * ThirdPartyPrintOwnerTypes
   */
  on(loadThirdPartyPrintOwnerTypes, state => ({...state, thirdPartyPrintOwnerTypes: []})),
  on(loadThirdPartyPrintOwnerTypesSuccess, (state, action) => ({
    ...state,
    thirdPartyPrintOwnerTypes: action.thirdPartyPrintOwnerTypes
  })),
  on(loadThirdPartyPrintOwnerTypesFailure, state => ({...state, thirdPartyPrintOwnerTypes: []})),

  on(loadThirdPartyCompanies, state => ({...state, thirdPartyCompanies: []})),
  on(loadThirdPartyCompaniesSuccess, (state, action) => ({...state, thirdPartyCompanies: action.thirdPartyCompanies})),
  on(loadThirdPartyCompaniesFailure, state => ({...state, thirdPartyCompanies: []})),
  /**
   * Ih refdata
   */
  on(loadIhComponents, state => ({...state, ihComponents: []})),
  on(loadIhComponentsSuccess, (state, action) => ({...state, ihComponents: action.ihComponents})),
  on(loadIhComponentsFailure, state => ({...state, ihComponents: []})),

  on(loadIhHealthPlans, state => ({...state, ihHealthPlans: []})),
  on(loadIhHealthPlansSuccess, (state, action) => ({...state, ihHealthPlans: action.ihHealthPlans})),
  on(loadIhHealthPlansFailure, state => ({...state, ihHealthPlans: []})),

  on(loadIhHealthPrograms, state => ({...state, ihHealthPrograms: []})),
  on(loadIhHealthProgramsSuccess, (state, action) => ({...state, ihHealthPrograms: action.ihHealthPrograms})),
  on(loadIhHealthProgramsFailure, state => ({...state, ihHealthPrograms: []})),
  on(clearIhHealthPrograms, state => ({...state, ihHealthPrograms: []})),

  on(loadIhPriorities, state => ({...state, ihPriorities: []})),
  on(loadIhPrioritiesSuccess, (state, action) => ({...state, ihPriorities: action.ihPriorities})),
  on(loadIhPrioritiesFailure, state => ({...state, ihPriorities: []})),

  on(loadReturnFileTypes, state => ({...state, returnFileTypes: []})),
  on(loadReturnFileTypesSuccess, (state, action) => ({...state, returnFileTypes: action.returnFileTypes})),
  on(loadReturnFileTypesFailure, state => ({...state, returnFileTypes: []})),

  on(loadImageFormatTypes, state => ({...state, ImageFormatTypes: []})),
  on(loadImageFormatTypesSuccess, (state, action) => ({...state, imageFormatTypes: action.imageFormatTypes})),
  on(loadImageFormatTypesFailure, state => ({...state, ImageFormatTypes: []}))
);
